<template>
	<div class="dialogue-talk-item" :class="{'active':index_name == source.session_id}" @click="clickTab(source)">
		<div class="avatar-box">
			<el-badge :value="source.unread_num" :max="99" class="item" :hidden="source.unread_num == 0">
				<img :src="source.headimgurl"/>
			</el-badge>
		   
		 </div>
		
		<div class="card-box">
			<div class="title">
			  <div class="card-name">
				  <p class="nickname">{{source.nickname}}</p>
				  <!-- <div class="larkc-tag">{{source.unread_num }}条未读</div> -->
				  <!-- <div class="larkc-tag top"> TOP </div> -->
				  <!-- <div class="larkc-tag group" >群组</div> -->
				  <!-- <div class="larkc-tag disturb">
				    <i class="el-icon-close-notification" />
				  </div> -->
			  </div>
			  <div class="card-time">
			    {{formateDate(source)}}
			  </div>
			</div>
			<div class="content">
				<template v-if="index_name != source.session_id && source.draft_text">
				  <span class="draft-color">[草稿]</span>
				  <span>{{source.draft_text }}</span>
				</template>
				<template v-else>
				  <span>{{ source.content }}</span>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapGetters,mapState} from 'vuex';
	import { friendlyFormatTime } from '@/utils/imService';
	export default {
		computed:{
			...mapState({
				index_name:state => state.imChatService.index_name
			})
		},
		props:{
			source: {
			  type: Object,
			  default () {
				return {}
			  }
			}
		},
		methods:{
			clickTab(data){
				this.$store.commit('imChatService/UPDATE_IM_OPERATE_LOGS',{
					type:`坐席切换会话`,
					content:`响应：${JSON.stringify(data)}`
				})
				this.$store.commit('imChatService/SET_INDEX_NAME',data.session_id);
				this.$store.commit('imChatService/SET_INDEX_INFOS',data);
				this.$nextTick(() => {
				  this.$store.commit('imChatService/UPDATE_TALK_ITEM', {
				    session_id:data.session_id,
				    unread_num: 0,
				  })
				})
				this.getChatSettingAuth(data);
			},
			formateDate(data){
				if(typeof data.sendtime == 'number') return friendlyFormatTime(this.$dayjs(data.sendtime).format('YYYY-MM-DD HH:mm:ss'));
				return friendlyFormatTime(data.sendtime);
			},
			//获取当前技能组聊天配置信息
			getChatSettingAuth(data){
				let result = [];
				this.$api.getSystemSatisfaction(data.skillGroup).then(res => {
					this.$store.commit('imChatService/UPDATE_IM_OPERATE_LOGS',{
						type:`获取当前会话聊天功能配置`,
						content:`响应：${JSON.stringify(res)}`
					})
					if(res.errcode != 0) return;
					result.push({
						name:'满意度',
						id:'autoSendScorePage',
						enabled:res.data.autoSendScorePage == 1
					})
					res.data.pageSwitchList.map(item => {
						result.push(item)
					})
					this.$store.commit('imChatService/UPDATE_CHAT_AUTH_SETTING',result);
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.dialogue-talk-item {
		padding: 20px;
		display: flex;
		flex-direction: row;
		align-items: center;
		cursor: pointer;
		box-sizing: border-box;
		&:hover {
			background: #F6F7F9;
		}
		&.active {
			background-color: #edf5ff;
		}
		.avatar-box {
		  height: 45px;
		  width: 45px;
		  flex-shrink: 0;
		  // background-color: #508afe;
		  border-radius: 50%;
		  display: flex;
		  justify-content: center;
		  align-items: center;
		  font-size: 14px;
		  color: white;
		  user-select: none;
		  transition: ease 1s;
		  position: relative;
		  // overflow: hidden;
		  ::v-deep {
			  .el-badge__content.is-fixed {
				  top: 0px;
				  right: 17px;
			  }
		  }
		
		  img {
		    width: 100%;
		    height: 100%;
		    background-color: white;
		    border-radius: 50%;
		  }
		}
		.card-box {
			height: 40px;
			display: flex;
			align-content: center;
			flex-direction: column;
			flex: 1 1;
			margin-left: 10px;
			overflow: hidden;
			
			.title {
			  width: 100%;
			  height: 20px;
			  display: flex;
			  align-items: center;
			
			  .card-name {
			    color: #1f2329;
			    font-size: 14px;
			    line-height: 20px;
			    flex: 1 1;
			    display: -webkit-flex;
			    display: -ms-flexbox;
			    display: flex;
			    align-items: center;
			    overflow: hidden;
			
			    .nickname {
			      font-weight: 400;
			      white-space: nowrap;
			      overflow: hidden;
			      text-overflow: ellipsis;
			      margin-right: 3px;
			    }
			
			    .top {
			      color: #dc9b04 !important;
			      background-color: #faf1d1 !important;
			    }
			
			    .group {
			      color: #3370ff !important;
			      background-color: #e1eaff !important;
			      font-size: 13px;
			    }
			
			    .disturb {
			      color: #98999c !important;
			      i {
			        font-size: 12px;
			      }
			    }
			  }
			}
			
			.card-time {
			  color: #8f959e;
			  font-size: 12px;
			  margin-left: 10px;
			  user-select: none;
			}
			
			.content {
			  font-size: 13px;
			  line-height: 18px;
			  color: #8f959e;
			  margin-top: 3px;
			  font-weight: 300;
			  overflow: hidden;
			  white-space: nowrap;
			  text-overflow: ellipsis;
			
			  span:first-child {
			    margin-right: 5px;
			  }
			
			  .online-color {
			    color: #4aa71c;
			    font-weight: 300;
			  }
			
			  .draft-color {
			    color: red;
			    font-weight: 300;
			  }
			}
			
			
		}
		&:hover {
		  background-color: #edf5ff;
		}
		&.active {
		  .avatar-box {
		    border-radius: 5px;
		  }
		
		  background-color: #edf5ff;
		}
	}
</style>
